import {Box, ListItem, ListItemAvatar, ListItemButton, ListItemText, Skeleton, Typography} from '@mui/material';
import {Link} from 'react-router-dom';
import IChannel from './IChannel';

interface IProps {
	channel: IChannel;
}

export default function MyChannel({channel}: IProps) {
	return (
		<ListItem className="p-0">
			<ListItemButton alignItems="flex-start" className="p-2 pt-0" component={Link} state={{channel}}
			                to={channel.name ? `/network/${channel.id}` : ''}>
				<ListItemAvatar>
					{
						channel.name ?
							<img className="w-10 h-10 rounded object-cover" src={channel.image} alt={channel.name}/>
							:
							<Skeleton width={40} height={40} variant="rounded"/>
					}
				</ListItemAvatar>
				<ListItemText
					primary={channel.name ?
						<Typography sx={{
							color: (theme) => theme.palette.mode === 'light' ? 'grey.800' : 'grey.100',
							fontSize: (theme) => theme.typography.fontSize
						}} className="font-medium">{channel.name}</Typography>
						:
						<Skeleton className="w-2/5"/>
					}
					secondary={channel.name ?
						<div className="flex flex-row items-center">
							{
								channel.isSeen &&
								<Box sx={{bgcolor: 'secondary.main'}} className="rounded-full w-[6px] h-[6px] ml-[2px]"></Box>
							}
							<Typography sx={{
								color: (theme) => theme.palette.mode === 'light' ? 'grey.600' : 'grey.200',
								fontSize: (theme) => theme.typography.fontSize - 2
							}} className="overflow-hidden whitespace-nowrap overflow-ellipsis">{channel.lastMessage}</Typography>
						</div>
						:
						<Skeleton className="w-4/5"/>
					}/>
				<Typography sx={{
					color: (theme) => theme.palette.mode === 'light' ? 'grey.500' : 'grey.300',
					fontSize: (theme) => theme.typography.fontSize - 2
				}} className="mt-2 w-8">{channel.name ? channel.lastTime.toLocaleTimeString('en-US', {
					hour12: false,
					hour: '2-digit',
					minute: '2-digit'
				}) : ''}</Typography>
			</ListItemButton>
		</ListItem>
	);
}
